// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".fr[data-v-4bad108a]{float:right}.fl[data-v-4bad108a]{float:left}.title[data-v-4bad108a]{height:60px;line-height:60px;background-color:#fff;padding:0 16px;margin-bottom:10px}.sub[data-v-4bad108a]{font-size:12px;margin-left:10px}", ""]);
// Exports
module.exports = exports;
